import { request } from '@/api/client';

export interface ServerVersion {
  version: string;
  commit: string;
  environment: string;
  release?: string | null;
  api_commit?: string | null;
  miniapp_commit?: string | null;
  bot_commit?: string | null;
}

export function getVersion(): Promise<ServerVersion> {
  return request<ServerVersion>('/utils/version');
}

export interface ClientConfig {
  min_android_version?: string | null;
}

export function getClientConfig(): Promise<ClientConfig> {
  return request<ClientConfig>('/utils/client-config');
}
